import { action, makeObservable, observable } from "mobx"

import type { VenammQuoteData } from "./types"

export class LockVenammQuoteCache {
  private quotes = observable.map<number, VenammQuoteData>()

  constructor() {
    makeObservable(this, {
      setQuote: action,
      clearQuote: action,
      clearAll: action,
    })
  }

  getQuote(lockId: number): VenammQuoteData | null {
    return this.quotes.get(lockId) ?? null
  }

  hasQuote(lockId: number): boolean {
    return this.quotes.has(lockId)
  }

  setQuote(lockId: number, quote: VenammQuoteData): void {
    this.quotes.set(lockId, quote)
  }

  clearQuote(lockId: number): void {
    this.quotes.delete(lockId)
  }

  clearAll(): void {
    this.quotes.clear()
  }

  getAllQuotes(): Map<number, VenammQuoteData> {
    return new Map(this.quotes)
  }
}
